import { Banner, Button } from "@foodpilot/foods";
import { Stack, useTheme } from "@mui/material";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { isRetryableRemoteErrorStatus, type RemoteErrorStatus } from "src/api/remoteCollectionState";

type RemoteErrorAlertProps = {
    message: ReactNode;
    onRetry?: () => void | Promise<unknown>;
    retryLabel?: ReactNode;
    status: RemoteErrorStatus;
};

export const RemoteErrorAlert = ({ message, onRetry, retryLabel, status }: RemoteErrorAlertProps) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const canRetry = onRetry !== undefined && isRetryableRemoteErrorStatus(status);

    return (
        <Stack alignItems="flex-start" gap={theme.spacing(2)} role="alert">
            <Banner variant="error">{message}</Banner>
            {canRetry && (
                <Button
                    onClick={() => {
                        void onRetry();
                    }}
                    variant="secondary"
                >
                    {retryLabel ?? t("common.actions.refresh", "Refresh")}
                </Button>
            )}
        </Stack>
    );
};
